import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { ROUTES } from '@/lib/routes';

const HQWholesale = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-4xl mx-auto">
        <Button variant="ghost" size="sm" asChild className="mb-4">
          <Link to={ROUTES.dashboard.root}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('back') || '返回'}
          </Link>
        </Button>
        <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
          {t('headquarters')} - {t('hqWholesale')}
        </h1>
        <p className="text-muted-foreground mt-2">
          {t('headquarters')} - {t('hqWholesale')}（佔位頁面）
        </p>
      </div>
    </div>
  );
};

export default HQWholesale;
